"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/CreateNew/NewChat/DraftChat.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');




var _attachments = require('shared/constants/attachments');
var _secureText = require('shared/constants/secureText');
var _org = require('shared/selectors/org');
var _attachmentLimit = require('shared/services/attachmentLimit');
var _entity = require('shared/services/entity');
var _string = require('shared/services/string');
var _uuid = require('shared/services/uuid');
var _newChatFlow = require('shared/services/createNew/newChatFlow');

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _hooks = require('web/services/hooks');
var _RightSide = require('web/components/RightSide');
var _Avatar = require('web/components/Avatar');

var _Composer = require('../Compose/Composer'); var _Composer2 = _interopRequireDefault(_Composer);
var _icons = require('../Compose/icons');

const NO_MENTIONS = []

// The unsent message and files. New chat holds them (useDraftMessage), so
// they outlive the draft while New chat is hidden behind another chat.
 const useDraftMessage = () => {
  const [text, setText] = _react.useState.call(void 0, '')
  const [files, setFiles] = _react.useState([])
  const [error, setError] = _react.useState(null)
  const nextFileId = _react.useRef.call(void 0, 0)
  const filesRef = _react.useRef.call(void 0, files)
  filesRef.current = files
  const addFiles = _react.useCallback.call(void 0, (added) => {
    const current = filesRef.current
    const room = Math.max(0, _attachments.MAX_ATTACHMENTS_PER_SEND - current.length)
    const leftOut = added.slice(room)
    if (leftOut.length) setError(_attachmentLimit.describeAttachmentsNotAdded.call(void 0, leftOut.map(file => file.name)))
    filesRef.current = [...current, ...added.slice(0, room).map(file => ({ id: nextFileId.current++, file }))]
    setFiles(filesRef.current)
  }, [])
  const removeFile = _react.useCallback.call(void 0, (id) => setFiles(current => current.filter(f => f.id !== id)), [])
  const clear = _react.useCallback.call(void 0, () => {
    setText('')
    setFiles([])
  }, [])

  // Leaving the inbox with a message typed asks first, as the compose did,
  // whether or not the draft is showing.
  const history = _reactrouterdom.useHistory.call(void 0, )
  _react.useEffect.call(void 0, () => {
    if (!text && !files.length) return
    return history.block(({ pathname }) => (
      pathname.startsWith('/inbox') ? undefined : 'Are you sure you want to leave? Your new message will be discarded.'
    ))
  }, [history, text, files.length])

  return _react.useMemo.call(void 0, 
    () => ({ text, setText, files, filesRef, addFiles, removeFile, clear, error, setError }),
    [text, files, addFiles, removeFile, clear, error],
  )
}; exports.useDraftMessage = useDraftMessage









/* A new one-to-one or patient chat before its first message, in the right
 * pane: the chat's header, who it's with and from, and today's composer.
 * Send creates the chat (named, for a named secure chat), opens it and sends
 * the message or files. Nothing is created until then. */
const DraftChat = ({ chat, draft, onBack, onOpen }) => {
  // SAFETY: a draft is opened with someone in To.
  const recipient = chat.selectedEntitiesList[0]
  const teamSender = chat.senderEntity && _entity.isEntityTeam.call(void 0, chat.senderEntity) ? chat.senderEntity : null
  const orgName = _hooks.useAppSelector.call(void 0, state => (chat.senderOrgKey && _optionalChain([_org.selectOrgByKey.call(void 0, chat.senderOrgKey, state), 'optionalAccess', _ => _.Name])) || '')
  const intro = _newChatFlow.newChatIntro.call(void 0, { chatType: chat.chatType, senderName: _nullishCoalesce(_optionalChain([teamSender, 'optionalAccess', _2 => _2.name]), () => ( null)), orgName, phone: chat.senderPhone })
  const title = chat.name.trim() || recipient.name

  const { text, setText, files, filesRef, addFiles, removeFile, clear, error, setError } = draft
  const [isSending, setIsSending] = _react.useState.call(void 0, false)
  const isSendingRef = _react.useRef.call(void 0, false)

  const onSend = _react.useCallback.call(void 0, async (message, mentions) => {
    const refuse = (reason) => {
      if (message) queueMicrotask(() => setText(message))
      if (reason) setError(reason)
    }
    if (isSendingRef.current) return refuse(null)
    if (chat.blocker) return refuse(chat.blocker)
    const pending = filesRef.current
    if (_string.isBlank.call(void 0, message) && !pending.length) return refuse(null)
    isSendingRef.current = true
    setIsSending(true)
    setError(null)
    let meta
    try {
      meta = await chat.createChat()
    } catch (e) {
      isSendingRef.current = false
      setIsSending(false)
      return refuse('Couldn\'t start the chat. Check the details and try again.')
    }
    clear()
    onOpen(meta)
    if (pending.length) {
      const caption = _string.isBlank.call(void 0, message) ? '' : message
      await _actions2.default.sendConversationAttachments(
        meta.ConversationKey,
        pending.map(p => ({ file: p.file, MessageKey: _uuid.uuidv4.call(void 0, )  })),
        caption,
        undefined,
        undefined,
        caption ? mentions : [],
      ).catch(() => null)
    } else {
      await _actions2.default.sendConversationMessage(meta.ConversationKey, message, undefined, undefined, undefined, undefined, mentions)
        .catch(() => null)
    }
  }, [chat, onOpen, filesRef, setText, setError, clear])

  return (
    _react2.default.createElement(_RightSide.RightSide, { inView: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}
      , _react2.default.createElement('div', { className: "new-chat-draft", __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
        , _react2.default.createElement('div', { className: "new-chat-draft--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}
          , _react2.default.createElement('button', { type: "button", className: "new-chat--icon-btn", 'aria-label': "Back", onClick: onBack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}
            , _react2.default.createElement(_icons.ChevronLeftIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}} )
          )
          , _react2.default.createElement(_Avatar.EntityAvatar, { entity: recipient, size: 40, __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}} )
          , _react2.default.createElement('div', { className: "new-chat-draft--titles", __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}
            , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 136}},  title )
            ,  chat.isInsecure
              ? _react2.default.createElement('span', { className: "new-chat-draft--tag", __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}, _react2.default.createElement(_icons.UnlockIcon, { size: 14, __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}} ),  _secureText.INSECURE_TEXT_LABEL )
              : _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}, "New chat" ) 
          )
        )
        , _react2.default.createElement(_RightSide.RightSideBody, { className: "new-chat-draft--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}}
          , _react2.default.createElement('div', { className: "new-chat-draft--intro", __self: this, __source: {fileName: _jsxFileName, lineNumber: 143}}
            , _react2.default.createElement(_Avatar.EntityAvatar, { entity: recipient, size: 56, __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}} )
            , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 145}},  recipient.name )
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 146}},  isSending ? 'Starting the chat…' : intro )
          )
          , _react2.default.createElement('div', { className: "compose-footer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}
            ,  error && (
              _react2.default.createElement('div', { className: "compose-error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}
                , _react2.default.createElement(_icons.AlertIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}} )
                , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 152}},  error )
              )
            )
            , _react2.default.createElement(_Composer2.default, {
              value: text,
              onChange: setText,
              onSend: onSend,
              files: files,
              onAddFiles: addFiles,
              onRemoveFile: removeFile,
              placeholder: chat.isInsecure ? _secureText.INSECURE_COMPOSER_PLACEHOLDER_WEB : 'Type your message…',
              isInsecure: chat.isInsecure,
              mentionCandidates: NO_MENTIONS, __self: this, __source: {fileName: _jsxFileName, lineNumber: 155}}
            )
          )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, DraftChat)
